
import React, {Component, useRef} from "react"
import { Loading } from '../component/BaseComponent';
import { HttpsRequest, Alerts } from '../component/Utils';
import {SideView} from "./loginui" ; 
import { APIRoute, APPRoute, RespStatus } from "../component/texts";
import {FormGroup} from "../component/form";



type InputFieldProp = {
    
    name:string,
    className: string,
    id: string,
    data: string,
    onchange: (event:React.ChangeEvent<HTMLInputElement>)=>void , 
    index: number ; 
     
}



interface IStateType {

    data: Record<string, number | string | unknown>
    form: Record<string, any>[];
    isbusy: boolean;
    page?: number;
    redirect: boolean;
    redirect_url?: string;
    redirect_data?: Record<string, number | string | unknown>[];
    email?: string ;
    disable_resend: boolean;
}

const InputField = ({className, id, name, data, onchange, index }: InputFieldProp ) => {

    const inputref = useRef<HTMLInputElement>(null)

    return (
        <input 
            ref={inputref}
            key={`field-${index}`}
            id={id} 
            className={className}
            value={data} 
            name={name}
            placeholder='Confirm OTP'
            style={{width: '100%'}}
            onChange={onchange} 
        />
    )
}

class OTPUI extends Component<IProps, IStateType> {

    constructor(props: IProps){

        super(props)
        this.state = {
            
            form: [],
            isbusy: false,
            data: {},
            redirect: false,
            email: '',
            disable_resend: false

        }
    }

    render(){
         
        return (

            <div className="row">
                <SideView /> 
                <div className="col-md-7 posrel"> 
                <div className="padh10 mt2">
                    <div className='mbt5'>
                        <p className='right'>
                            <a href={'#'} className={this.state.disable_resend? 'nodecor text-muted': 'nodecor' } onClick={this.resend_otp}>
                                <span className='text-muted'> did not receive the otp? </span> 
                                &nbsp; Resend
                            </a>
                        </p>
                    </div>
                    <form method='post' autoComplete="off" onSubmit={this.submit_otp}>
                        
                        <div className="d-flex flex-column justify-content-around mt5" style={{minHeight: 250}}>

                        {
                            this.state.form.map((fld, idx) => {
                                
                                return <FormGroup key={`sign${idx}`}
                                    obj={fld} 
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        this.onchange(e);                                         
                                    }} />
                                
                            })
                        }
                         
                        </div>
                        <div className="d-grid">
                            <button type="submit" className="btn btn-primary btn-lg btn-block">
                                Confirm OTP 
                            </button>
                        </div>
                         
                    </form>
                </div>
                {this.state.isbusy && <Loading />}
                </div>
            </div> 
        )
 
    }

     

    componentDidMount(): void {
        
        const {state} = this.props.location;

        this.setState(
            {form: state.form, email: state.email}
        );         

    }

    onchange = (event: React.ChangeEvent<HTMLInputElement>) => {
                
        const name: string = event.target.name;

        let value: string = event.target.value;
        
        const {data} = this.state ; 
                        
        this.setState({ data: Object.assign({}, data, { [name]: value }) });  
                
    }

    resend_otp = (event: React.MouseEvent<HTMLAnchorElement>) => {
        
        event.preventDefault();

        if (this.state.disable_resend === true){
            Alerts.show_info('please wait one minute before trying to resend another otp'); 
            return 
        }
         
        const {email} = this.props.location.state; 

        const success_func = (r:RespArgs) => {
                        
            if (r.status === RespStatus.success){
                this.setState({isbusy: false, disable_resend: true}) ;  

                setTimeout(()=>{
                    this.setState({disable_resend: false})
                }, 60000)
                
                Alerts.show_info(r.status_msg);

            } else if (r.status === RespStatus.failed){
                
                Alerts.show_error(r.status_msg);
                this.setState({isbusy: false})
            
            }

        } 

        const error_handler = (r:RespArgs) => {
            // only when necessary 
        }


        HttpsRequest.post(
            APIRoute.resend_otp,
            {email},
            success_func, 
            {},
            error_handler
        )
        
        this.setState({isbusy: true}) ; 

    }

    submit_otp = (event: React.MouseEvent<HTMLFormElement>) => {

        event.preventDefault();

        this.setState({isbusy: true});

        const {data} = this.state ; 
        
        data.email = this.props.location.state.email;

        const success_func = (r:RespArgs) => {
            if (r.status === RespStatus.success){
                this.setState(
                    {isbusy: false }, () => {
                        this.props.navigate(APPRoute.login); 
                        Alerts.show_success(r.status_msg);
                    }
                )
            } else if (r.status === RespStatus.failed){ 
                this.setState({
                    isbusy: false 
                }, () => {
                    Alerts.show_error(r.body.fields[0]); 
                    if (r.body.form !== undefined){
                        this.setState({form: r.body.form})
                    }
                })
            }
        } 

        const error_handler = (r:RespArgs) => {
            console.log(r); 
        }

        HttpsRequest.post(
            APIRoute.confirm_otp,
            data,
            success_func,
            {},
            error_handler
        )


    }

}


  
export default OTPUI ; 

